import { Spacing } from '@persona-id/design-tokens';
import { VFC } from 'react';
import styled from 'styled-components';

import ReactSelect from 'dashboard/components/ReactSelect';
import Input from 'design-system/components/Input';
import { paragraphMixins } from 'design-system/mixins/text';
import { JsonSchemaTypes } from 'lib/json-schema';

const REACT_SELECT_PORTAL_ID_PREFIX = 'trigger-config-api-code-live-test-payload-editor';

const StyledInput = styled(Input)`
  height: ${({ theme }) => theme.element.height.xs};
  ${paragraphMixins.md};
`;

const TextFieldContainer = styled.div<{ widthPercentage: number | null }>`
  width: ${({ widthPercentage }) => widthPercentage}%;
  margin-left: ${Spacing[2]};
`;

const ReactSelectContainer = styled.div<{ widthPercentage: number | null }>`
  width: ${({ widthPercentage }) => (widthPercentage ? `${widthPercentage}%` : '144px')};
  margin-left: ${Spacing[2]};
`;

interface TriggerLiveTestPayloadFieldProps {
  value: any;
  updateValue: (value: any) => void;
  widthPercentage: number | null;
}

const TriggerLiveTestPayloadField: VFC<TriggerLiveTestPayloadFieldProps> = ({
  value,
  updateValue,
  widthPercentage,
}) => {
  return (
    <>
      {typeof value === JsonSchemaTypes.String && (
        <TextFieldContainer widthPercentage={widthPercentage}>
          <StyledInput
            id={`${REACT_SELECT_PORTAL_ID_PREFIX}__string-input`}
            aria-label='Field string value'
            value={value as string}
            onChange={(e) => {
              const newFieldValue = e.target.value;
              updateValue(newFieldValue);
            }}
            autoFocus
          />
        </TextFieldContainer>
      )}
      {typeof value === JsonSchemaTypes.Boolean && (
        <ReactSelectContainer widthPercentage={widthPercentage}>
          <ReactSelect
            id={`${REACT_SELECT_PORTAL_ID_PREFIX}__boolean-selector`}
            aria-label='Field boolean value'
            value={String(value)}
            options={[
              {
                label: 'True',
                value: 'true',
              },
              {
                label: 'False',
                value: 'false',
              },
            ]}
            onChange={(value) => updateValue(value === 'true')}
          />
        </ReactSelectContainer>
      )}
      {typeof value === JsonSchemaTypes.Number && (
        <TextFieldContainer widthPercentage={widthPercentage}>
          <StyledInput
            id={`${REACT_SELECT_PORTAL_ID_PREFIX}__number-input`}
            aria-label='Field number value'
            value={value as number}
            type='number'
            onChange={(e) => {
              const newFieldKey = e.target.value;
              updateValue(parseInt(newFieldKey));
            }}
            autoFocus
          />
        </TextFieldContainer>
      )}
    </>
  );
};

export default TriggerLiveTestPayloadField;
